import { Heart, Download } from 'lucide-react';
import { GALLERY_FAVORITES, GALLERY_SELECTIONS, GALLERY_DOWNLOAD } from '@/constants/testIds';

/** Counts + "favorites only" filter + Download All, shown to the owning client. */
export const ClientGalleryToolbar = ({ favoriteCount, selectionCount, selectionLimit, favoritesOnly, onToggleFavoritesOnly, onDownloadAll }) => (
  <div className="flex flex-wrap items-center gap-3">
    <span className="text-xs text-[hsl(var(--lxra-muted))]" data-testid={GALLERY_FAVORITES.count}>
      {favoriteCount} favorite{favoriteCount === 1 ? '' : 's'}
    </span>
    <span className="text-xs text-[hsl(var(--lxra-muted))]" data-testid={GALLERY_SELECTIONS.count}>
      {selectionCount}{selectionLimit != null ? ` / ${selectionLimit}` : ''} selected
    </span>
    <button
      type="button"
      onClick={onToggleFavoritesOnly}
      aria-pressed={favoritesOnly}
      data-testid={GALLERY_FAVORITES.filter}
      className={`inline-flex items-center gap-2 h-10 px-4 rounded-full border text-xs uppercase tracking-[0.1em] transition-colors ${
        favoritesOnly
          ? 'border-[hsl(var(--lxra-gold))] bg-[hsl(var(--lxra-gold))]/15 text-[hsl(var(--lxra-gold-hover))]'
          : 'border-[hsl(var(--lxra-border))] text-[hsl(var(--lxra-fg))] hover:border-[hsl(var(--lxra-gold))]/60 hover:text-[hsl(var(--lxra-gold))]'
      }`}
    >
      <Heart className={`h-3.5 w-3.5 ${favoritesOnly ? 'fill-current' : ''}`} />
      Favorites only
    </button>
    <button
      type="button"
      onClick={onDownloadAll}
      data-testid={GALLERY_DOWNLOAD.allButton}
      className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))] text-xs uppercase tracking-[0.1em] font-semibold transition-colors"
    >
      <Download className="h-3.5 w-3.5" />
      Download All
    </button>
  </div>
);
